import React from "react";
import DOMPurify from "dompurify";
import ImageUpload from'./Markdown-upload';

class SafeHtmlPreview extends React.Component {
    constructor(props) {
        super(props);
        this.containerRef = React.createRef();
    }
    componentDidMount() {
        if (this.containerRef.current) {
            this.containerRef.current.innerHTML = DOMPurify.sanitize(this.props.html || '');
        }
    }
    componentDidUpdate(prevProps) {
        if (prevProps.html !== this.props.html && this.containerRef.current) {
            this.containerRef.current.innerHTML = DOMPurify.sanitize(this.props.html || '');
        }
    }
    render() {
        return <div className={this.props.className} ref={this.containerRef} />;
    }
}

export default class extends React.Component {


    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.valid = this.valid.bind(this);

        const {field, formData} = this.props;
        formData[field.name] = formData[field.name] || field.default;

        this.state = {
            valid: true,
            mode:"edit",
            id:Math.random()
        }
    }

    handleChange(event) {
        const {field, config, formData} = this.props;
        formData[field.name] = event.target.value;
        this.valid();
        try {
            this.props.onChange()
        } catch (e) {

        }
    }

    changeMode = (e)=>{
        this.setState({
            "mode":e.target.getAttribute("data-mode") || "edit"
        })
    }

    uploadFile =(file)=>{
        const imgHTML = `\r <img src="${file.linkUrl}" />`;
        const {field,formData} = this.props;
        formData[field.name] =(formData[field.name] || "")+ imgHTML;
        this.setState({
            id:Math.random()
        })
    }

    valid() {
        const {field, config, formData} = this.props;

        if (!field.required) {
            return true
        }

        this.setState({
            valid: !!formData[field.name]
        })


    }

    generateRenderedContent(){
        const {field, config,formData} = this.props;
        const rawContent = window["marked"]
            ? window["marked"].parse(formData[field.name] || "")
            : (formData[field.name] || "");
        return <SafeHtmlPreview html={rawContent} className="preview" />;
    }

    render() {
        const {field, config,formData} = this.props;
        const {valid,mode,id} = this.state;
        const formID = this.props.id;
        const safeHelpText = DOMPurify.sanitize(field.helpText || "", { ALLOWED_TAGS: [], ALLOWED_ATTR: [] });

        let title = field.title;
        if(title.substr(-1) == "*"){
            title = title.slice(0, -1)
        }
        if (field.required) {
            title = <span>{title} <span className='pubhub-smartsheet-form-required'>*</span></span>
        }

        let content = null;

        if(mode == "edit"){
            content = <textarea className="form-control"
                            rows={field.maxRows}
                            aria-describedby={field.id + 'passwordHelpBlock'}
                            id={field.id}
                            defaultValue={formData[field.name]}
                            onChange={this.handleChange}
                            onBlur={this.valid}
                            key={id}
                            idx={id}
                    ></textarea>
        }else{
            content = this.generateRenderedContent()
        }

        return (
            <div
                className={"row pubhub-smartsheet-form-element pubhub-smartsheet-markdown " + (valid ?"": "has-danger")}
                key={field.id}>
                <div className="pubhub-smartsheet-label">
                    <label htmlFor={field.id} className="col-form-label">{title}</label>
                </div>
                <div className="pubhub-smartsheet-element"  key={formID}>
                    <small id={field.id + 'passwordHelpBlock'} className="form-text text-muted">{safeHelpText}</small>
                    <ul className="nav nav-tabs">
                        <li className="nav-item">
                            <a className={"nav-link " + (mode=="edit"?"active":"")} onClick={this.changeMode} data-mode="edit">Edit</a>
                        </li>
                        <li className="nav-item">
                            <a className={"nav-link " + (mode=="preview"?"active":"")}  onClick={this.changeMode}  data-mode="preview">Preview</a>
                        </li>

                        <li>
                            {/* <a href="https://www.markdownguide.org/basic-syntax/" target="_blank" className="md_link" tabIndex="-1" rel="noopener noreferrer">Markdown</a> */}
                            <ImageUpload onUploaded={this.uploadFile}/>
                            </li>
                        </ul>
                    {content}

                </div>
            </div>

        )
    }
}
